import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Lock } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Centraliza fotos que llegan por WhatsApp', 'Permite reenviar fotos desde correos', 'Consolida cientos de imágenes en un solo lugar', 'Mantiene el historial accesible online de forma permanente', 'Acceso web ordenado por fecha, obra y proyecto'];
  return <section id="solucion" className="py-16 sm:py-24 bg-white" data-id="element-268">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12" data-id="element-270">
          <h2 className="text-sm font-semibold text-blue-600 tracking-wide uppercase mb-2" data-id="element-271">
            La solución
          </h2>
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-272">
            De grupo de WhatsApp a registro ordenado
          </h3>
          <p className="text-lg sm:text-xl text-gray-600" data-id="element-273">
            Obra Digital convierte tu grupo de WhatsApp en un registro ordenado
            de obra, sin que tu equipo tenga que aprender a usar nada nuevo.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-blue-50 border border-blue-100 rounded-xl p-4 sm:p-6 text-center mb-10 sm:mb-12 max-w-2xl mx-auto" data-id="element-274">
          <p className="text-base sm:text-lg text-blue-900 font-medium" data-id="element-275">
            Obra Digital no cambia cómo trabaja tu equipo. Solo captura,
            estructura y respalda la información.
          </p>
        </motion.div>

        <div className="lg:grid lg:grid-cols-12 lg:gap-12 items-center" data-id="element-276">
          {/* Bullets */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-5 mb-10 lg:mb-0" data-id="element-277">
            <ul className="space-y-4 sm:space-y-5" data-id="element-278">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-279">
                  <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-280" />
                  <span className="ml-2.5 sm:ml-3 text-base sm:text-lg text-gray-700" data-id="element-281">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="mt-6 sm:mt-8 flex items-start" data-id="element-282">
              <Lock className="h-5 w-5 sm:h-6 sm:w-6 text-gray-900 flex-shrink-0 mt-0.5 mr-2.5 sm:mr-3" data-id="element-283" />
              <p className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-284">
                Todo queda almacenado y disponible cuando lo necesites. Aunque
                el grupo de WhatsApp se borre.
              </p>
            </div>
          </motion.div>

          {/* Before / After Visual */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-7" data-id="element-285">
            <div className="bg-gray-50 rounded-2xl p-2 sm:p-4 border border-gray-200 flex flex-col sm:flex-row items-center gap-4" data-id="element-286">
              {/* Before */}
              <div className="flex-1 w-full bg-white rounded-xl border border-red-100 p-4 shadow-sm relative overflow-hidden" data-id="element-287">
                <div className="absolute top-0 left-0 w-full h-1 bg-red-400" data-id="element-288"></div>
                <div className="flex justify-between items-center mb-4" data-id="element-289">
                  <span className="text-xs font-bold text-red-500 uppercase tracking-wider bg-red-50 px-2 py-1 rounded" data-id="element-290">
                    Antes
                  </span>
                </div>
                <div className="relative h-48 bg-red-50/30 rounded-lg border border-red-100/50 p-2" data-id="element-291">
                  {/* Messy layout */}
                  <div className="absolute top-2 left-2 w-16 h-16 rounded border-2 border-white shadow-sm rotate-6 overflow-hidden bg-gray-100" data-id="element-292">
                    <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300&h=300&fit=crop" alt="Antes 1" className="w-full h-full object-cover" data-id="element-293" />
                  </div>
                  <div className="absolute top-10 left-12 w-20 h-14 rounded border-2 border-white shadow-sm -rotate-12 overflow-hidden bg-gray-100" data-id="element-294">
                    <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=300&h=300&fit=crop" alt="Antes 2" className="w-full h-full object-cover" data-id="element-295" />
                  </div>
                  <div className="absolute bottom-4 right-4 w-24 h-24 rounded border-2 border-white shadow-sm rotate-3 overflow-hidden bg-gray-100" data-id="element-296">
                    <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=300&h=300&fit=crop" alt="Antes 3" className="w-full h-full object-cover" data-id="element-297" />
                  </div>
                  <div className="absolute top-4 right-8 bg-white p-2 rounded-lg shadow-sm text-[8px] text-gray-500 max-w-[80px]" data-id="element-298">
                    "Foto de ayer"
                  </div>
                </div>
              </div>

              {/* Arrow */}
              <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-200 shadow-sm z-10 shrink-0" data-id="element-299">
                <ArrowRight className="w-5 h-5 text-gray-400" data-id="element-300" />
              </div>
              <div className="sm:hidden flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-200 shadow-sm z-10 shrink-0 rotate-90 my-[-1rem]" data-id="element-301">
                <ArrowRight className="w-5 h-5 text-gray-400" data-id="element-302" />
              </div>

              {/* After */}
              <div className="flex-1 w-full bg-white rounded-xl border border-blue-100 p-4 shadow-sm relative overflow-hidden" data-id="element-303">
                <div className="absolute top-0 left-0 w-full h-1 bg-blue-500" data-id="element-304"></div>
                <div className="flex justify-between items-center mb-3" data-id="element-305">
                  <span className="text-xs font-bold text-blue-600 uppercase tracking-wider bg-blue-50 px-2 py-1 rounded" data-id="element-306">
                    Después
                  </span>
                  <span className="text-[9px] text-gray-400 font-medium" data-id="element-307">
                    Piso 3 — Sector Norte
                  </span>
                </div>
                <div className="relative h-48 bg-blue-50/20 rounded-lg border border-blue-100/50 overflow-hidden" data-id="element-308">
                  {/* Floor Plan SVG */}
                  <svg width="100%" height="100%" viewBox="0 0 300 200" className="absolute inset-0 opacity-25" preserveAspectRatio="xMidYMid meet" data-id="element-309">
                    <rect x="15" y="15" width="270" height="170" fill="none" stroke="#9CA3AF" strokeWidth="1.5" data-id="element-310" />
                    <line x1="110" y1="15" x2="110" y2="185" stroke="#9CA3AF" strokeWidth="1.5" data-id="element-311" />
                    <line x1="200" y1="15" x2="200" y2="110" stroke="#9CA3AF" strokeWidth="1.5" data-id="element-312" />
                    <line x1="15" y1="110" x2="110" y2="110" stroke="#9CA3AF" strokeWidth="1.5" data-id="element-313" />
                    <line x1="200" y1="110" x2="285" y2="110" stroke="#9CA3AF" strokeWidth="1.5" data-id="element-314" />
                    {/* Doors */}
                    <rect x="108" y="55" width="4" height="20" fill="white" data-id="element-315" />
                    <rect x="108" y="140" width="4" height="20" fill="white" data-id="element-316" />
                    <rect x="60" y="108" width="20" height="4" fill="white" data-id="element-317" />
                  </svg>

                  {/* Pin 1 — top left room */}
                  <div className="absolute top-[22%] left-[18%] group" data-id="element-318">
                    <div className="w-5 h-5 bg-blue-500 rounded-full border-2 border-white shadow-md flex items-center justify-center z-10 relative" data-id="element-319">
                      <div className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-320"></div>
                    </div>
                    <div className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded border-2 border-white shadow-md overflow-hidden bg-gray-100 z-20" data-id="element-321">
                      <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=150&h=150&fit=crop" alt="Foto pin 1" className="w-full h-full object-cover" data-id="element-322" />
                    </div>
                  </div>

                  {/* Pin 2 — bottom left room */}
                  <div className="absolute top-[68%] left-[25%] group" data-id="element-323">
                    <div className="w-5 h-5 bg-blue-500 rounded-full border-2 border-white shadow-md flex items-center justify-center z-10 relative" data-id="element-324">
                      <div className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-325"></div>
                    </div>
                    <div className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded border-2 border-white shadow-md overflow-hidden bg-gray-100 z-20" data-id="element-326">
                      <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=150&h=150&fit=crop" alt="Foto pin 2" className="w-full h-full object-cover" data-id="element-327" />
                    </div>
                  </div>

                  {/* Pin 3 — top right area */}
                  <div className="absolute top-[28%] right-[22%] group" data-id="element-328">
                    <div className="w-5 h-5 bg-blue-500 rounded-full border-2 border-white shadow-md flex items-center justify-center z-10 relative" data-id="element-329">
                      <div className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-330"></div>
                    </div>
                    <div className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded border-2 border-white shadow-md overflow-hidden bg-gray-100 z-20" data-id="element-331">
                      <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=150&h=150&fit=crop" alt="Foto pin 3" className="w-full h-full object-cover" data-id="element-332" />
                    </div>
                  </div>

                  {/* Pin 4 — bottom right */}
                  <div className="absolute top-[65%] right-[15%] group" data-id="element-333">
                    <div className="w-5 h-5 bg-blue-500 rounded-full border-2 border-white shadow-md flex items-center justify-center z-10 relative" data-id="element-334">
                      <div className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-335"></div>
                    </div>
                    <div className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded border-2 border-white shadow-md overflow-hidden bg-gray-100 z-20" data-id="element-336">
                      <img src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=150&h=150&fit=crop" alt="Foto pin 4" className="w-full h-full object-cover" data-id="element-337" />
                    </div>
                  </div>

                  {/* Small metadata label */}
                  <div className="absolute bottom-2 left-2 bg-white/90 backdrop-blur-sm rounded px-2 py-1 shadow-sm border border-gray-100 z-30" data-id="element-338">
                    <span className="text-[8px] text-gray-500 font-medium" data-id="element-339">
                      4 fotos · 15 ene 2026
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}